export const colors = {
  gray: {
    100: '#F2F2F2',
    300: '#C4C4C4',
    500: '#999',
    600: '#333'
  },
  blue: {
    100: '#f4fbfb',
    500: '#05314A'
  },
  teal: {
    500: '#94D4D6'
  },
  green: {
    500: '#73D873'
  },
  red: {
    500: '#A9273D'
  },
  orange: {
    500: '#FF714D'
  }
};
